module.exports = __webpack_public_path__ + "static/img/yb4.64283236.png";